/**
 * Tool Constants
 * Shared constants for tool components
 */

export interface ToolCategory {
  slug: string;
  label: string;
  icon?: string;
}

// Tool categories - technical and healthcare-specific
export const TOOL_CATEGORIES: ToolCategory[] = [
  // Technical categories
  { slug: "agent-fundamentals", label: "Agent Building", icon: "robot" },
  { slug: "tools-integrations", label: "Integrations", icon: "plug" },
  { slug: "deployment", label: "Deployment", icon: "rocket" },
  { slug: "best-practices", label: "Best Practices", icon: "check" },
  // Healthcare categories
  { slug: "personal-productivity", label: "Productivity", icon: "clock" },
  { slug: "clinical-tools", label: "Clinical", icon: "stethoscope" },
  { slug: "revenue-cycle", label: "Revenue Cycle", icon: "dollar" },
  { slug: "admin-operations", label: "Admin", icon: "building" },
];
